<template>
	<div v-if="current && contestConfigurationLoaded">
		<compareTitles
			:current="current.title"
			:old="old.title"
		/>

		<compare-english-titles
			:current="current.englishTitle"
			:old="old.englishTitle"
		/>

		<compare-priority-tree
			:contest-id="contestId"
			:current="current.prioritiesData"
			:old="old.prioritiesData"
		/>

		<compare-summary-bidder-details
			:current-main="current.mainBidder"
			:old-main="old.mainBidder"
			:current-others="current.otherBidders"
			:old-others="old.otherBidders"
		/>

		<compare-countries-fundings
			:contest-id="contestId"
			:current="current.financesData"
			:old="old.financesData"
		/>

		<compare-dac-codes
			:contest-id="contestId"
			:current="current.dacCodes"
			:old="old.dacCodes"
		/>

		<div v-for="i in (numberOfModules !== 0 ? numberOfModules : 1)" :key="i">

			<egranty-section-divider
				v-if="numberOfModules > 1"
				:text=moduleTitle(i)
			/>

			<compare-start-end
				:current="current.stepsConstantData[i-1].dates"
				:old="old.stepsConstantData[i-1].dates"
				:number-of-modules="numberOfModules"
				:module-number="i"
			></compare-start-end>

			<compare-volunteers
				:current="current.stepsConstantData[i-1].volunteers"
				:current-global-init="current.stepsConstantData[i-1].globalInitiative"
				:current-global-init-description="current.stepsConstantData[i-1].globalInitiativeDescription"
				:old="old.stepsConstantData[i-1].volunteers"
				:old-global-init="old.stepsConstantData[i-1].globalInitiative"
				:old-global-init-description="old.stepsConstantData[i-1].globalInitiativeDescription"
			/>

			<compare-actions
				:contest-id="contestId"
				:current="current.stepsConstantData[i-1].actionsData"
				:old="old.stepsConstantData[i-1].actionsData"
				:number-of-modules="numberOfModules"
				:module-number="i"
			/>

			<compare-locations
				:current="current.stepsConstantData[i-1].locations"
				:old="old.stepsConstantData[i-1].locations"
			/>

			<compare-costs-table
				:configuration="contestConfiguration"

				:old-actions="old.stepsConstantData[i-1].actionsData"
				:old-administrative-costs="old.stepsConstantData[i-1].administrativeCosts"

				:current-actions="current.stepsConstantData[i-1].actionsData"
				:current-administrative-costs="current.stepsConstantData[i-1].administrativeCosts"
			/>

			<compare-costs-calculated-table
				:old-actions="old.stepsConstantData[i-1].actionsData"
				:old-administrative="old.stepsConstantData[i-1].administrativeCosts"

				:actions="current.stepsConstantData[i-1].actionsData"
				:administrative="current.stepsConstantData[i-1].administrativeCosts"
			/>

			<div v-for="(section, index) in moduleGenericMap(i)" v-bind:key="(index+100) * i">
				<h2 style="margin-left: 20px">{{contestConfiguration.moduleSchema.sections[index].name}}</h2>
				<vue-form-generator
					:disabled="true"
					:name="'generator-'.concat(index).concat('-').concat(i)"
					:model="section.model"
					:schema="section.schema"
				/>
			</div>
		</div>
		<div v-for="(section, index) in persistentGenericMap()" v-bind:key="index+10000">
			<h2 style="margin-left: 20px">{{contestConfiguration.persistentSchema.sections[index].name}} </h2>
			<vue-form-generator
				:disabled="true"
				:name="'persistentGenerator-'.concat(index)"
				:model="section.model"
				:schema="section.schema"
			/>
		</div>
	</div>
</template>

<script>
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import {Offer} from "@/api/generated/Offer";
	import {Api} from "@/api";
	import CompareTitles from "../offer/compareComponents/CompareTitles";
	import CompareEnglishTitles from "../offer/compareComponents/CompareEnglishTitles";
	import ComparePriorityTree from "../offer/compareComponents/ComparePriorityTree";
	import CompareCountriesFundings from "../offer/compareComponents/CompareCountriesFundings";
	import CompareDacCodes from "../offer/compareComponents/CompareDacCodes";
	import CompareStartEnd from "../offer/compareComponents/CompareStartEnd";
	import CompareActions from "../offer/compareComponents/CompareActions";
	import CompareLocations from "../offer/compareComponents/CompareLocations";
	import CompareCostsTable from "../offer/compareComponents/CompareCostsTable";
	import EgrantySectionDivider from "../../../genericComponents/EgrantySectionDivider";
	import CompareCostsCalculatedTable from "./components/CostsCalculatedTableComponents/CompareCostsCalculatedTable";
	import CompareVolunteers from "./compareComponents/CompareVolunteers";
  import CompareSummaryBidderDetails from "@/view/logged/offer/compareComponents/CompareSummaryBidderDetails";

	export default {
		name: "CompareOffersView",

		components: {
      CompareSummaryBidderDetails,
			CompareVolunteers,
			CompareCostsCalculatedTable,
			CompareCostsTable,
			CompareLocations,
			CompareActions,
			CompareStartEnd,
			CompareDacCodes,
			CompareCountriesFundings,
			ComparePriorityTree,
			CompareEnglishTitles,
			CompareTitles,
			EgrantySectionDivider,
		},

		data() {
			return {
				old: null,
				current: null,
				offerId: this.$route.params.offerId,
				firstVersion: this.$route.params.firstVersion,
				secondVersion: this.$route.params.secondVersion,
				contestId: this.$route.params.id,
				contestConfiguration: {},
				contestConfigurationLoaded: false,
			};
		},

		computed: {
			numberOfModules() {
				if (this.contestConfiguration.moduleSchema) {
					return this.old.stepsConstantData.length;
				} else {
					return 0;
				}
			},
		},

		methods: {
			modelHasNullProperties(model) {
				for (let prop in model) {
					if (model.hasOwnProperty(prop) && !model[prop]) {
						return true;
					}
				}
				return false;
			},

			moduleGenericMap(moduleNumber) {
				if (this.contestConfiguration.moduleSchema === null || this.old.moduleGenericModel === null || this.modelHasNullProperties(this.old.moduleGenericModel)) {
					return null;
				} else {
					let sectionsArray = [];
					for (let i = 0; i < this.contestConfiguration.moduleSchema.sections.length; i++) {
						sectionsArray.push(this.prepareSchemaAndModelForSectionAndModule(i, moduleNumber));
					}
					return sectionsArray;
				}
			},

			persistentGenericMap() {
				if (this.contestConfiguration.persistentSchema === null
					|| this.old.persistentGenericModel === null
					|| this.current.persistentGenericModel === null) {
					return null;
				} else {
					let sectionsArray = [];
					for (let i = 0; i < this.contestConfiguration.persistentSchema.sections.length; i++) {
						sectionsArray.push(this.prepareSchemaAndModelForSection(i));
					}
					return sectionsArray;
				}
			},

			prepareSchemaAndModelForSection(i) {
				let oldSchema = this.getPersistentSchemaForComparing(this.old.persistentGenericModel, i);
				let currentSchema = this.getPersistentSchemaForComparing(this.current.persistentGenericModel, i);
				return genericFormUtil.mergeTwoSchemasAndModelToCompare(oldSchema, currentSchema, this.old.persistentGenericModel.sections[i], this.current.persistentGenericModel.sections[i]);
			},

			getPersistentSchemaForComparing(model, sectionIndex) {
				let sections = model.sections;
				let schema = genericFormUtil.getSectionSchemaFromSchema(this.contestConfiguration.persistentSchema, sectionIndex, true);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = sections[sectionIndex].fields;
					return genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
				} else {
					return schema;
				}
			},

			prepareSchemaAndModelForSectionAndModule(i, moduleNumber) {
				let oldSchema = this.getModuleSchemaForComparing(this.old.moduleGenericModel, i, moduleNumber);
				let currentSchema = this.getModuleSchemaForComparing(this.current.moduleGenericModel, i, moduleNumber);
				return genericFormUtil.mergeTwoSchemasAndModelToCompare(oldSchema, currentSchema, this.old.moduleGenericModel[moduleNumber].sections[i], this.current.moduleGenericModel[moduleNumber].sections[i]);
			},

			getModuleSchemaForComparing (model, sectionIndex, moduleNumber) {
				let sections = model[moduleNumber].sections;
				let schema = genericFormUtil.getSectionSchemaFromSchema(this.contestConfiguration.moduleSchema, sectionIndex, true);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = sections[sectionIndex].fields;
					return genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
				} else {
					return schema;
				}
			},

			moduleTitle(i) {
				return "Moduł " + i.toString();
			},

			initializeContestConfiguration(response) {
				this.contestConfiguration.moduleSchema = genericFormUtil.decodeSchema(response.moduleSchema);
				this.contestConfiguration.persistentSchema = genericFormUtil.decodeSchema(response.persistentSchema);
				this.contestConfiguration.firstPossibleOfferDate = response.firstPossibleOfferDate;
				this.contestConfiguration.lastPossibleOfferDate = response.lastPossibleOfferDate;
				this.contestConfiguration.volunteersAvailable = response.volunteersAvailable;
				this.contestConfiguration.volunteersRequired = response.volunteersRequired;
				this.contestConfiguration.modulePriceLimit = response.modulePriceLimit;
			},


			getModuleModel(response) {
				if (this.numberOfModules > 0) {
					let mapOld = {};
					let mapNew = {};
					for (let i = 1; i <= this.numberOfModules; i++) {
						mapOld[i] = genericFormUtil.decodeSchema(response.old.moduleGenericModel[i]);
						mapNew[i] = genericFormUtil.decodeSchema(response.current.moduleGenericModel[i]);
					}
					response.old.moduleGenericModel = mapOld;
					response.current.moduleGenericModel = mapNew;
				}
			},

			getPersistentModel(response) {
				response.old.persistentGenericModel = genericFormUtil.decodeSchema(response.old.persistentGenericModel);
				response.current.persistentGenericModel = genericFormUtil.decodeSchema(response.current.persistentGenericModel);
			},
		}
		,

		async created() {
			await Api.syncGet(this, "/public-contest/offer-configuration?offerId=".concat(this.offerId), response => {
					this.contestConfigurationLoaded = true;
					this.initializeContestConfiguration(response);
				},
				errorResponse => this.$messagesBus.$emit("error", "Nie udało się wczytać konfiguracji oferty!", errorResponse),
			);
			Offer.getCompareData(
				this,
				this.offerId,
				this.firstVersion,
				this.secondVersion,
				(response) => {
					this.old = response.old;
					this.current = response.current;
					this.getModuleModel(response);
					this.getPersistentModel(response);
				},
			);
		}
		,
	}
	;
</script>

<style>
	.old {
		background-color: #ff7777;
	}
	.new {
		background-color: #81c081;
	}

	.new.form-group.disabled > label,
	.old.form-group.disabled > label {
		color: #535353;
	}

	.v-textarea textarea {
		padding: 8px;
	}

	.new .theme--light.v-input--is-disabled textarea,
	.old .theme--light.v-input--is-disabled textarea {
		color: #626262;
	}

	.vue-form-generator .new .v-text-field__slot,
	.vue-form-generator .old .v-text-field__slot {
		border: 1px solid #d7d7d7;
	}
</style>